import type { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const classNamePrefix = 'lapidary-textInputWithLabel--'
export const selectors = {
  container: `${classNamePrefix}container`,
} as const

export const container: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
}

export const label: CSSObject = {
  marginBlockEnd: Spacing.XS / 2,
}
